export const defaultContexts = {
    GBR: {
        iso_2: "GB",
        iso_3: "GBR",
        emoji: "🇬🇧",
        rgeo: true,
        description: "United Kingdom",
    },
    USA: {
        iso_2: "US",
        iso_3: "USA",
        emoji: "🇺🇸",
        rgeo: false,
        description: "United States",
    },
};
export const toContextList = (contexts, restrictCountries) => {
    const result = [];
    const codes = Object.keys(contexts);
    for (const code of codes) {
        if (restrictCountries.length > 0 &&
            !restrictCountries.some((e) => e === code))
            continue;
        result.push(contexts[code]);
    }
    result.sort((b, a) => b.description.localeCompare(a.description));
    return result;
};
export const toContextMap = (contexts) => {
    const result = {};
    for (const context of contexts) {
        result[context.iso_3] = context;
    }
    return result;
};
